var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14302_8399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0137 14.875C19.0137 14.5298 18.7339 14.25 18.3887 14.25H11.9512C11.606 14.25 11.3262 14.5298 11.3262 14.875C11.3262 15.2202 11.606 15.5 11.9512 15.5H18.3887C18.7339 15.5 19.0137 15.2202 19.0137 14.875Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9512 16.75C11.606 16.75 11.3262 17.0298 11.3262 17.375C11.3262 17.7202 11.606 18 11.9512 18H15.8609C16.2061 18 16.4859 17.7202 16.4859 17.375C16.4859 17.0298 16.2061 16.75 15.8609 16.75H11.9512Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4204 22.75H11.3301C10.6408 22.75 10.0801 22.1892 10.0801 21.5V10.5C10.0801 9.81075 10.6408 9.25 11.3301 9.25H19.0141C19.7034 9.25 20.2641 9.81075 20.2641 10.5V14.3438C20.2641 14.6889 20.5439 14.9688 20.8891 14.9688C21.2343 14.9688 21.5141 14.6889 21.5141 14.3438V10.5C21.5141 9.1215 20.3926 8 19.0141 8H11.3301C9.95158 8 8.83008 9.1215 8.83008 10.5V21.5C8.83008 22.8785 9.95158 24 11.3301 24H13.4204C13.7655 24 14.0454 23.7202 14.0454 23.375C14.0454 23.0298 13.7655 22.75 13.4204 22.75Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6208 17.0484C21.8897 16.3173 20.7002 16.3173 19.9696 17.0479L16.5383 20.4716C16.4654 20.5443 16.4116 20.6339 16.3817 20.7324L15.6344 23.1926C15.5682 23.4107 15.6259 23.6475 15.7851 23.8107C15.9043 23.9329 16.0663 23.9992 16.2325 23.9992C16.2881 23.9992 16.3442 23.9918 16.3993 23.9765L18.922 23.2777C19.0258 23.249 19.1204 23.1939 19.1966 23.1178L22.6208 19.7001C23.3519 18.969 23.3519 17.7795 22.6208 17.0484ZM18.4299 22.117L17.1608 22.4686L17.5322 21.2458L19.8475 18.9356L20.7315 19.8197L18.4299 22.117ZM21.7374 18.8158L21.6163 18.9367L20.7324 18.0527L20.853 17.9323C21.0967 17.6886 21.4932 17.6886 21.7369 17.9323C21.9806 18.176 21.9806 18.5725 21.7374 18.8158Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3887 11.75H11.9512C11.606 11.75 11.3262 12.0298 11.3262 12.375C11.3262 12.7202 11.606 13 11.9512 13H18.3887C18.7339 13 19.0137 12.7202 19.0137 12.375C19.0137 12.0298 18.7339 11.75 18.3887 11.75Z",
    fill: "#7F56D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14302_8399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalNote);
export default __webpack_public_path__ + "static/media/clinicalNote.20be4c1693fa36cdfe879edadc2f9486.svg";
export { ForwardRef as ReactComponent };